<template>
	<v-chip :color="unsyncedCount == 0 ? 'primary' : 'error'" text-color="white" disabled>
        <v-avatar :class="{
            'white font-weight-bold': true,
            'primary--text': unsyncedCount == 0,
            'error--text': unsyncedCount != 0
        }">{{ unsyncedCount }}</v-avatar>
        <span>{{ name }}</span>
    </v-chip>
</template>

<script>
export default {
    props: [
        'name',
        'unsyncedCount'
    ]
}
</script>